import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { PoBreadcrumb, PoDialogService, PoNotificationService } from '@po-ui/ng-components';
import { AcumuladoresService } from './acumuladores.service';

@Component({
  selector: 'app-acumuladores',
  templateUrl: './acumuladores.component.html',
  styleUrls: ['./acumuladores.component.css'],
  standalone: false
})
export class AcumuladoresComponent {

  readonly breadcrumb: PoBreadcrumb = {
    items: [{ label: 'Home', link: '/home' }, { label: 'Contabilidade' }, { label: 'Acumuladores' }]
  };

  idEmpresa: number | null = null;
  isLoading = false;

  constructor(
    private readonly acumuladoresService: AcumuladoresService,
    private readonly poDialogService: PoDialogService,
    private readonly poNotificationService: PoNotificationService
  ) { }

  requestAcumuladores(form: NgForm) {
    if (!form.valid || !this.idEmpresa || this.idEmpresa <= 0) {
      this.poNotificationService.warning('Selecione a empresa para gerar o relatório.');
      return;
    }

    this.isLoading = true;
    this.acumuladoresService.requestAcumuladores(this.idEmpresa).subscribe({
      next: () => {
        this.poDialogService.alert({
          title: 'Relatório - Acumuladores',
          message: 'Relatório solicitado com sucesso. Dentro de instantes você receberá um e-mail com a planilha de acumuladores da empresa.'
        });
        form.reset();
        this.idEmpresa = null;
      },
      error: () => {
        this.isLoading = false;
        this.poNotificationService.error('Não foi possível solicitar o relatório de acumuladores. Tente novamente.');
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }
}
